import { 
  faWifi, 
  faKey, 
  faExclamationTriangle,
  faQuestion,
  faCode,
  faShieldDog
} from '@fortawesome/free-solid-svg-icons';

// Import des constantes core (sans dépendances UI)
export {
  CIRCUIT_STATES,
  STANDARD_STATUS_CODES,
  WORKER_STATE
} from '@commons-shared/circuit-breaker-constants-core.js';

/**
 * Types d'erreurs avec leurs configurations complètes (version UI avec icônes)
 * Centralisées pour simplifier la maintenance
 */
export const ERROR_TYPES = {
  connectivity: {
    type: 'connectivity',
    icon: faWifi,
    translationKey: 'ERROR_TYPE_CONNECTIVITY',
    defaultText: 'Connectivité',
    cssClass: 'status-error--connectivity'
  },
  auth: {
    type: 'auth',
    icon: faKey,
    translationKey: 'ERROR_TYPE_AUTH',
    defaultText: 'Authentification',
    cssClass: 'status-error--auth'
  },
  service: {
    type: 'service',
    icon: faExclamationTriangle,
    translationKey: 'ERROR_TYPE_SERVICE',
    defaultText: 'Service',
    cssClass: 'status-error--service'
  },
  api: {
    type: 'api',
    icon: faCode,
    translationKey: 'ERROR_TYPE_API',
    defaultText: 'API',
    cssClass: 'status-error--api'
  },
  watchdog: {
    type: 'watchdog',
    icon: faShieldDog,
    translationKey: 'ERROR_TYPE_WATCHDOG',
    defaultText: 'Appels répétés détectés',
    cssClass: 'status-error--watchdog'
  },
  unknown: {
    type: 'unknown',
    icon: faQuestion,
    translationKey: 'ERROR_TYPE_UNKNOWN',
    defaultText: 'Erreur inconnue',
    cssClass: 'status-error--unknown'
  }
};